import { z } from 'zod';

// Identifiers — UUIDv7-shaped strings, but we accept any UUID format.
export const uuid = z.string().uuid();

// Money — BigInt cents serialized as a string for JSON safety.
// Example: 12500000 cents = Rp 125.000,00
export const moneyCents = z.string().regex(/^-?\d+$/, 'Expected integer-string cents');

// ISO-8601 datetime string. Server emits, client parses to local time.
export const isoDatetime = z.string().datetime();

// Date-only string, e.g. '2026-06-25'.
export const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');

// Cursor pagination
export const paginationQuery = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  cursor: z.string().optional(),
});
export type PaginationQuery = z.infer<typeof paginationQuery>;

export const paginatedResponse = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });

// Error envelope — every non-2xx response uses this shape.
export const errorResponse = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).optional(),
  }),
});
export type ErrorResponse = z.infer<typeof errorResponse>;
